import React, { useState } from 'react';
import DailyReportListByDate from './DailyReportListByDate';
import LoadingSpinner from '../utils/LoadingSpinner';
import TwoColumnSwitch from '../utils/TwoColumnSwitch';
import DailyReportListByCompany from './DailyReportListByCompany';

const DailyReportListTableContainer = ({ dailyReportList, hasMore, loading, handleShowMore, sortBy, setSortBy }) => {
    return (
        <div className="dailyReportTableContainer">
            {loading && (
            <div className="loading-status flex align-items-center">
            <LoadingSpinner size={42} />
            </div>
        )}
        {/* <TwoColumnSwitch titleLeft="日付ごと" titleRight="企業ごと" onChange={handleColumnSwitch} /> */}
        <div className="daily-report-list">
            {sortBy === 'date' && dailyReportList.map((dailyReports) => (
                <DailyReportListByDate
                    key={dailyReports.date}
                    date={dailyReports.date}
                    dailyReports={dailyReports.dailyReports}
                />
            ))}
            {sortBy === 'company' && dailyReportList.map((dailyReports) => (
                <DailyReportListByCompany
                    key={dailyReports.secCode}
                    secCode={dailyReports.secCode}
                    companyName={dailyReports.companyName}
                    dailyReports={dailyReports.dailyReports}
                />
            ))}
        </div>
        {hasMore && !loading && (
            <button onClick={handleShowMore} className="more-button">
            Show More
            </button>
        )}
        </div>
    );
};

export default DailyReportListTableContainer;
